import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CSVLink } from "react-csv";
import { Spin } from "react-cssfx-loading";
import TitlePage from "../../Shared/TitlePage";
import DevExDataTable from "./Components/DevExDataTable";
import { dataService } from "../../../Services/data/data.service";
import MyDateTimePicker from "../../Shared/DateSelection/DateTimePicker";
import { valueTypeCodes, resultColumns, controlTypes, timeLineVisualisationTypes, externalApiTypes } from "../../../Config/constants";
import TimeLineChart from "./Components/TimeLineChart";
import TimeRangeChart from "./Components/TimeRangeChart";
import DatePickerText from "../../Shared/DateSelection/DatePickerText";
import { parseNewDateToYYMMDDDash, parseNewDateToDDMMYYYWithoutSeconds } from "../../../Utils/dateHelper";
import { makeStyles } from "@material-ui/core/styles";
import { ChevronLeft, ChevronDown, RefreshCcw, MapPin, Factory } from "lucide-react";
import { toast } from "react-toastify";
import { Divider, Button, ButtonGroup, Typography, Collapse, IconButton, Box, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

// Components
import BoolToggle from "../../Shared/Buttons/BoolToggle";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  "&:hover": {
    background: "rgba(195, 153, 107, 0.85) !important",
  },
  padding: 0,
  color: "white",
  transform: !expand ? "rotate(180deg)" : "rotate(0deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

function ResultsPage(props) {
  const classes = useStyles();
  const navigate = useNavigate();

  const { projectQr } = useParams(); //Project QR from URL
  const [project, setProject] = useState(null);
  const [measurementRows, setMeasurementRows] = useState([]);
  const [chartRows, setChartRows] = useState([]);

  const [showLinearTimeline, setShowLinearTimeline] = useState(false);

  const [originalMeasurementRows, setOriginalMeasurementRows] = useState([]); // Original copy of measurement rows - not to be overwritten
  const GetUserId = props.Login.userid;
  const [types, setTypes] = useState([]);
  const [selectedProject, setSelectedProject] = useState(false);
  const [timeLineData, setChartData] = useState({});
  const [timeRangeData, setTimeRangeData] = useState([]);
  const [exportActive, setExportActive] = useState(false);
  const [location, setLocation] = useState("");
  const [projectName, setProjectName] = useState("");
  const [openSearch, setOpenSearch] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const anchorRef = React.useRef(null);
  const [isLoading, setLoading] = useState(true);
  const [timeRangeDates, setTimeRangeDates] = useState({
    fromDate: new Date(Date.now() - 86400000),
    startDate: new Date(Date.now() - 86400000),
    toDate: new Date(Date.now()),
    endDate: new Date(Date.now()),
  });

  const [filtersCopy, setFiltersCopy] = useState(null); // Copy of filters set by DevExDataTable
  const [isFiltering, setIsFiltering] = useState(false); // Track filtering state
  const filterTimeoutRef = useRef(null); // Ref for debounce timeout

  const chartDummyData = [
    {
      commentText: "Process started",
      commentImage: "",
      checked: true,
      id: 6041,
      startDate: "2024-12-03T10:12:45.123Z",
      endDate: "2024-12-03T10:32:45.000Z",
      companyName: "FictiefBedrijf",
      measurementValue: "00:20:00",
      type: "Stopwatch",
      projectName: "Project Alpha",
      resource: "Machine 2387",
      typeId: 2,
      key: null,
      counter: null,
      insertedOn: "2024-12-03T11:12:45.123",
      updatedOn: "2024-12-03T11:32:45",
      description: "Process start timer",
      color: "#ff6600",
      chartType: "rangeBar",
      argumentField: "description",
      detailId: 3501,
    },
    {
      commentText: null,
      commentImage: null,
      checked: true,
      id: 6040,
      startDate: "2024-12-03T10:05:30.456Z",
      endDate: "2024-12-03T10:25:30.000Z",
      companyName: "FictiefBedrijf",
      measurementValue: "00:20:00",
      type: "Stopwatch",
      projectName: "Project Beta",
      resource: "Machine 1243",
      typeId: 2,
      key: null,
      counter: null,
      insertedOn: "2024-12-03T11:05:30.456",
      updatedOn: "2024-12-03T11:25:30",
      description: "Pause timer",
      color: "#00cc00",
      chartType: "rangeBar",
      argumentField: "description",
      detailId: 3502,
    },
    {
      commentText: "Error encountered",
      commentImage: "",
      checked: true,
      id: 6039,
      startDate: "2024-12-03T09:55:00.123Z",
      endDate: "2024-12-03T10:55:00.000Z",
      companyName: "FictiefBedrijf",
      measurementValue: "01:00:00",
      type: "Stopwatch",
      projectName: "Project Gamma",
      resource: "Machine 3562",
      typeId: 2,
      key: null,
      counter: null,
      insertedOn: "2024-12-03T10:55:00.123",
      updatedOn: "2024-12-03T11:55:00",
      description: "Error recovery timer",
      color: "#ff0000",
      chartType: "rangeBar",
      argumentField: "description",
      detailId: 3503,
    },
    {
      commentText: "All systems go",
      commentImage: "",
      checked: true,
      id: 6038,
      startDate: "2024-12-03T09:45:30.223Z",
      endDate: "2024-12-03T10:45:30.000Z",
      companyName: "FictiefBedrijf",
      measurementValue: "01:00:00",
      type: "Stopwatch",
      projectName: "Project Delta",
      resource: "Machine 4589",
      typeId: 2,
      key: null,
      counter: null,
      insertedOn: "2024-12-03T10:45:30.223",
      updatedOn: "2024-12-03T11:45:30",
      description: "System check timer",
      color: "#33cc33",
      chartType: "rangeBar",
      argumentField: "description",
      detailId: 3504,
    },
    {
      commentText: null,
      commentImage: null,
      checked: true,
      id: 6037,
      startDate: "2024-12-03T09:40:15.987Z",
      endDate: "2024-12-03T09:55:15.000Z",
      companyName: "FictiefBedrijf",
      measurementValue: "00:15:00",
      type: "Stopwatch",
      projectName: "Project Epsilon",
      resource: "Machine 5291",
      typeId: 2,
      key: null,
      counter: null,
      insertedOn: "2024-12-03T10:40:15.987",
      updatedOn: "2024-12-03T10:55:15",
      description: "Startup timer",
      color: "#0099cc",
      chartType: "rangeBar",
      argumentField: "description",
      detailId: 3505,
    },
    {
      commentText: "System failure",
      commentImage: "",
      checked: true,
      id: 6036,
      startDate: "2024-12-03T09:25:30.135Z",
      endDate: "2024-12-03T13:25:30.000Z",
      companyName: "FictiefBedrijf",
      measurementValue: "04:00:00",
      type: "Stopwatch",
      projectName: "Project Zeta",
      resource: "Machine 6123",
      typeId: 2,
      key: null,
      counter: null,
      insertedOn: "2024-12-03T10:25:30.135",
      updatedOn: "2024-12-03T14:25:30",
      description: "System downtime",
      color: "#ff3333",
      chartType: "rangeBar",
      argumentField: "description",
      detailId: 3506,
    },
  ];

  //DevExData
  const [selection, setSelection] = useState([]);

  useEffect(() => {
    var apiCalls = [];
    var tempMeasurementRows;

    var objProject;
    var objTypes;
    if (projectQr) {
      //If we have a projectQR --> Get the measurements for that specific project
      apiCalls = [dataService.getMeasurementsByQrCode(projectQr), dataService.getTypes(), dataService.getProjectByProjectQr(projectQr)];
    } else {
      //We don't have a project, so just get all measurements for the last 24h
      apiCalls = [
        dataService.getMeasurementsByUserIdDate(props.Login.userid, parseNewDateToYYMMDDDash(timeRangeDates.fromDate), parseNewDateToYYMMDDDash(timeRangeDates.toDate)),
        dataService.getTypes(),
      ];
    }

    //Execute the api-calls
    Promise.all(apiCalls)
      .then((results) => {
        var measurementResult = results[0];
        var typeResult = results[1];
        var projectResult;
        //Check if we have project-data
        if (projectQr) {
          projectResult = results[2];
          objProject = projectResult;
        }
        objProject = projectResult;
        objTypes = typeResult.sort((a, b) => a.description.localeCompare(b.description));

        var element = getLatestStartTimeElement(measurementResult);
        var from = timeRangeDates.fromDate;
        var to = timeRangeDates.toDate;

        //If a project is selected only display the elements that took place in the last 24h of the last event
        if (projectQr && element !== null && element !== undefined) {
          to = new Date(element.startTime);
          from = new Date(element.startTime);
          from.setHours(from.getHours() - 24);
          const formattedDate = from.toString();
          from = formattedDate;
          setTimeRangeDates({ fromDate: new Date(from), startDate: new Date(from), toDate: to, endDate: to });
        }

        tempMeasurementRows = measurementResult.map((y, index) => ({
          index: index,
          checked: checkBetweenDate(new Date(y.startTime), new Date(from), new Date(to)),
          projectId: y.projectId,
          toDate: y.toDate,
          fromDate: y.fromDate,
          color: y.color,
          id: y.id,
          typeId: y.typeId,
          companyId: y.companyId,
          qrCode: y.qrCode,
          companyName: y.companyName,
          detailId: y.projectDetailId,
          projectName: y.projectName,
          resourceId: y.resourceId,
          resourceName: y.resourceName,
          description: y.description,
          startTime: y.startTime,
          stopTime: y.stopTime,
          startHour: getStartHour(y.startTime),
          startDayOfWeek: getStartDayOfWeek(y.startTime),
          insertedOn: y.startTime,
          updatedOn: y.stopTime,
          measurementSessionId: y.measurementSessionId,
          measurementValue: getMeasurementValue(
            y.typeId,
            y.externalApiTypeId,
            y.textValue,
            y.integerValue,
            y.dateValue,
            y.dataListValue,
            y.imageLink,
            y.externalApiValues,
            y.isNegative,
            y.numericValue
          ),
          integerValue: y.integerValue,
          numericValue: y.numericValue,
          running: y.running,
          thumbnail: y.thumbnail,
          imageId: y.imageId,
          commentText: getCommentText(y.typeId, y.externalApiTypeId, y.textValue, y.commentText),
          commentImage: y.commentImage,
          commentId: y.commentId,
          valueTypeId: y.valueTypeId,
          valueType: getValueType(y.valueTypeId),
          keyValue: y.keyValue,
          eventPrice: y.eventPrice,
          signedEventPrice: y.isProfit ? y.eventPrice : -y.eventPrice,
          externalApiTypeId: y.externalApiTypeId,
          isNegative: y.isNegative,
          isProfit: y.isProfit,
          sessionValues: y.metadata ? JSON.parse(y.metadata).map(m => m.value).join(', ') : '',
          sessionMetadata: y.metadata ? JSON.parse(y.metadata) : [],
        }));

        const selectionPromise = new Promise((resolve) => {
          const indexes = tempMeasurementRows.map((item, index) => (item.checked ? index : -1)).filter((index) => index !== -1);
          setSelection(indexes);
          setExportActive(true);
          resolve();
        });

        const projectPromise = new Promise((resolve) => {
          if (projectQr) {
            setProject(objProject);
            setSelectedProject(true);
          } else {
            setSelectedProject(false);
          }
          resolve();
        });

        const typesPromise = new Promise((resolve) => {
          setTypes(objTypes);
          resolve();
        });

        const measurementsPromise = new Promise((resolve) => {
          if (tempMeasurementRows !== undefined && tempMeasurementRows !== null) {
            setMeasurementRows(tempMeasurementRows.flat().sort((b, a) => a.startTime.localeCompare(b.startTime)));
            var data = chartData(tempMeasurementRows.flat());
            setChartRows(data);
            setOriginalMeasurementRows(tempMeasurementRows.flat().sort((b, a) => a.startTime.localeCompare(b.startTime)));
          }
          resolve();
        });

        // Wait for all state updates to complete before setting loading to false
        Promise.all([selectionPromise, projectPromise, typesPromise, measurementsPromise]).then(() => {
          setLoading(false); // Only set loading to false after all updates
        });
      })
      .catch((error) => {
        toast.error(`A problem occured while fetching the data`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        console.log("Error: ", error);
      })
      .finally(() => {
        //All api-calls are finished, start setting states
      });
  }, [projectQr, props.Login.userid]); // eslint-disable-line react-hooks/exhaustive-deps

  const getValueType = (id) => {
    switch (id) {
      case valueTypeCodes.VA:
        return "Value added";
      case valueTypeCodes.NVA:
        return "No value added";
      case valueTypeCodes.W:
        return "Waste";
      default:
        return "Unknown";
    }
  };

  const checkBetweenDate = (date, fromDate, toDate) => {
    //check if the date variable is between from- and todate
    return date >= fromDate && date <= toDate;
  };

  const getLatestStartTimeElement = (data) => {
    //We check the latest measurement -> this is how we will decide from where to start the 'last 24h'
    if (data !== null && data.length > 0) {
      return data.reduce((latest, current) => {
        const latestTime = new Date(latest.startTime);
        const currentTime = new Date(current.startTime);

        // Check if current startTime is later than the latest
        return currentTime > latestTime ? current : latest;
      });
    } else {
      return null;
    }
  };

  const limitString = (str, limit) => {
    if (str.length > limit) {
      return str.substring(0, limit) + "...";
    } else {
      return str;
    }
  };

  const getStartHour = (startTime) => {
    if (startTime !== null && startTime !== undefined) {
      const date = new Date(startTime);
      return date.getHours();
    } else {
      return null;
    }
  };

  const getStartDayOfWeek = (startTime) => {
    if (startTime !== null && startTime !== undefined) {
      const date = new Date(startTime);
      const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
      return days[date.getDay()];
    } else {
      return null;
    }
  };

  const chartData = (data) => {
    let tempdata = [];
    let tempObj = {};

    data.forEach((x) => {
      let startDate = new Date(x.startTime);
      let tempEndDate = new Date(x.startTime);
      let insertedOn = new Date(x.startTime);
      let updatedOn = new Date(x.startTime);

      if (x.typeId === controlTypes.STOPWATCH || (x.typeId === controlTypes.EXTERNALAPI && x.externalApiTypeId === externalApiTypes.STOPWATCH)) {
        if (x.updatedOn !== undefined) {
          updatedOn = x.updatedOn;
        }
        if (x.stopTime !== null && x.stopTime.length > 0) {
          tempEndDate = new Date(x.stopTime);
        }
        if (x.insertedOn !== undefined) {
          insertedOn = x.insertedOn;
        }
        tempObj = {
          commentText: x.commentText,
          commentImage: x.commentImage,
          checked: x.checked,
          id: x.id,
          startDate: startDate,
          endDate: tempEndDate,
          companyName: x.companyName,
          measurementValue: x.measurementValue,
          type: "Stopwatch",
          projectName: x.projectName,
          resource: x.resourceName,
          typeId: x.typeId,
          value: x.dateValue,
          key: x.keyValue,
          counter: null,
          insertedOn: insertedOn,
          updatedOn: updatedOn,
          description: limitString(x.description, 15),
          color: x.color,
          chartType: "rangeBar",
          argumentField: "description",
          detailId: x.detailId,
          linearTimeline: "",
          externalApiTypeId: x.externalApiTypeId,
        };
      } else if (x.typeId === controlTypes.COUNTER) {
        tempObj = {
          commentText: x.commentText,
          commentImage: x.commentImage,
          checked: x.checked,
          id: x.id,
          startDate: startDate,
          endDate: tempEndDate,
          companyName: x.companyName,
          measurementValue: x.measurementValue,
          type: "Counter",
          projectName: x.projectName,
          resource: x.resourceName,
          typeId: x.typeId,
          value: x.integerValue,
          key: x.keyValue,
          counter: x.measurementValue,
          counterDescription: limitString(x.description, 15),
          color: x.color,
          chartType: "scatter",
          argumentField: "counterDescription",
          linearTimeline: "",
        };
      } else if (x.typeId === controlTypes.FREETEXT) {
        tempObj = {
          commentText: x.commentText,
          commentImage: x.commentImage,
          checked: x.checked,
          id: x.id,
          startDate: startDate,
          endDate: tempEndDate,
          companyName: x.companyName,
          measurementValue: x.measurementValue,
          type: "Free text",
          projectName: x.projectName,
          resource: x.resourceName,
          typeId: x.typeId,
          value: x.textValue,
          key: x.keyValue,
          counter: null,
          freetextDescription: limitString(x.description, 15),
          color: x.color,
          linearTimeline: "",
        };
      } else if (x.typeId === controlTypes.DATALIST) {
        tempObj = {
          commentText: x.commentText,
          commentImage: x.commentImage,
          checked: x.checked,
          id: x.id,
          startDate: startDate,
          endDate: tempEndDate,
          companyName: x.companyName,
          measurementValue: x.measurementValue,
          type: "Data list",
          projectName: x.projectName,
          resource: x.resourceName,
          typeId: x.typeId,
          key: x.keyValue,
          datalistDescription: limitString(x.description, 15),
          counter: null,
          color: x.color,
          linearTimeline: "",
        };
      } else if (x.typeId === controlTypes.CAMERA) {
        tempObj = {
          commentText: x.commentText,
          commentImage: x.commentImage,
          checked: x.checked,
          id: x.id,
          startDate: startDate,
          endDate: tempEndDate,
          companyName: x.companyName,
          measurementValue: x.measurementValue,
          type: "Image",
          projectName: x.projectName,
          resource: x.resourceName,
          typeId: x.typeId,
          key: x.keyValue,
          image: x.imageId,
          thumbnail: x.thumbnail,
          cameraDescription: limitString(x.description, 15),
          counter: null,
          color: x.color,
          linearTimeline: "",
        };
      } else if (x.typeId === controlTypes.SCANNER) {
        tempObj = {
          commentText: x.commentText,
          commentImage: x.commentImage,
          checked: x.checked,
          id: x.id,
          startDate: startDate,
          endDate: tempEndDate,
          companyName: x.companyName,
          measurementValue: x.measurementValue,
          type: "Data list",
          projectName: x.projectName,
          resource: x.resourceName,
          typeId: x.typeId,
          key: x.keyValue,
          datalistDescription: limitString(x.description, 15),
          counter: null,
          color: x.color,
          linearTimeline: "",
        };
      } else if (x.typeId === controlTypes.EXTERNALAPI) {
        tempObj = {
          commentText: x.commentText,
          commentImage: x.commentImage,
          checked: x.checked,
          id: x.id,
          startDate: startDate,
          endDate: tempEndDate,
          companyName: x.companyName,
          measurementValue: x.measurementValue,
          type: "External API",
          projectName: x.projectName,
          resource: x.resourceName,
          typeId: x.typeId,
          key: x.keyValue,
          value: x.textValue,
          externalApiDescription: limitString(x.description, 15),
          counter: null,
          color: x.color,
          linearTimeline: "",
          externalApiTypeId: x.externalApiTypeId,
        };
      }

      tempdata.push(tempObj);
    });
    tempdata = tempdata.filter((x) => x.checked);
    return tempdata;
  };

  const getMeasurementValue = (TypeId, externalApiTypeId, Text, Int, Time, DataListValue, ImageLink, ExternalApiValue, isNegative, numericValue) => {
    switch (TypeId) {
      case 1:
        return Int;
      case 2:
        if (Int > 0) {
          return Time;
        } else {
          return "";
        }
      case 3:
        return Text;
      case 4:
        return DataListValue;
      case 5:
        return Text;
      case 6:
        return ImageLink;
      case 7:
        if (externalApiTypeId === externalApiTypes.STOPWATCH) {
          if (Int > 0) {
            return Time;
          } else {
            return "";
          }
        } else if (externalApiTypeId === externalApiTypes.NUMERIC) {
          if (isNegative) {
            return `-${numericValue}`;
          } else {
            return numericValue;
          }
        } else if (externalApiTypeId === externalApiTypes.TEXT) {
          return Text;
        }
        return Text;
      default:
        return Int;
      // eslint-disable-next-line
    }
  };

  const getCommentText = (typeId, externalApiTypeId, text, commentText) => {
    switch (typeId) {
      case 1:
        return commentText;
      case 2:
        return commentText;
      case 3:
        return commentText;
      case 4:
        return commentText;
      case 5:
        return commentText;
      case 6:
        return commentText;
      case 7:
        if (externalApiTypeId === externalApiTypes.STOPWATCH) {
          return text;
        } else if (externalApiTypeId === externalApiTypes.NUMERIC) {
          return text;
        } else if (externalApiTypeId === externalApiTypes.TEXT) {
          return commentText;
        }
        return commentText;
      default:
        return "";
      // eslint-disable-next-line
    }
  };

  const headers = [
    { label: "Customer", key: "companyName" },
    { label: "Project name", key: "projectName" },
    { label: "Registration point", key: "resourceName" },
    { label: "Description", key: "description" },
    { label: "Value Type", key: "valueTypeId" },
    { label: "Value", key: "measurementValue" },
    { label: "Key Value", key: "keyValue" },
    { label: "Start Time", key: "startTime" },
    { label: "Running", key: "running" },
    { label: "Comment", key: "commentText" },
  ];

  const updateDataRange = (data, changeDay) => {
    let tempToDate = new Date(data[1]);
    let tempFromDate = new Date(data[0]);
    var duplicateDateRange = JSON.parse(JSON.stringify(timeRangeDates));

    var objNewTimeRangeDate;

    if (changeDay) {
      //IF it was a 'changeDay' action we start again with a 24h range
      objNewTimeRangeDate = { startDate: new Date(tempFromDate), fromDate: new Date(tempFromDate), toDate: new Date(tempToDate), endDate: new Date(tempToDate) };
    } else {
      //If slider was changed
      objNewTimeRangeDate = { startDate: new Date(duplicateDateRange.startDate), fromDate: new Date(tempFromDate), toDate: new Date(tempToDate), endDate: new Date(duplicateDateRange.endDate) };
    }

    if (projectQr !== undefined && projectQr !== null && projectQr !== "") {
      let tempRows = JSON.parse(JSON.stringify(originalMeasurementRows));

      //IF we are on a specific project-page; then we should just check the elements that are needed
      tempRows.forEach((x) => {
        if (
          (new Date(x.startTime) >= tempFromDate && new Date(x.startTime) <= tempToDate) ||
          (x.stopTime !== null && x.stopTime !== "" && new Date(x.stopTime) >= tempFromDate && new Date(x.stopTime) <= tempToDate)
        ) {
          x.checked = true;
        } else {
          x.checked = false;
        }
      });

      const selectionPromise = new Promise((resolve) => {
        const indexes = tempRows.map((item, index) => (item.checked ? index : -1)).filter((index) => index !== -1);
        setSelection(indexes);
        setExportActive(true);
        resolve();
      });

      const measurementsPromise = new Promise((resolve) => {
        if (tempRows !== undefined && tempRows !== null) {
          setMeasurementRows(tempRows.flat().sort((b, a) => a.startTime.localeCompare(b.startTime)));
          var data = chartData(tempRows.flat());
          setChartRows(data);
        }
        resolve();
      });

      Promise.all([selectionPromise, measurementsPromise]).then(() => {
        setLoading(false); // Only set loading to false after all updates
      });
    } else {
      var tempMeasurementRows = [];
      //No project selected, fetch all measurements that you might need
      dataService
        .getMeasurementsByUserIdDate(props.Login.userid, parseNewDateToYYMMDDDash(objNewTimeRangeDate.startDate), parseNewDateToYYMMDDDash(objNewTimeRangeDate.endDate))
        .then((results) => {
          tempMeasurementRows = results.map((y, index) => ({
            index: index,
            checked: checkBetweenDate(new Date(y.startTime), new Date(objNewTimeRangeDate.fromDate), new Date(objNewTimeRangeDate.toDate)),
            projectId: y.projectId,
            toDate: y.toDate,
            fromDate: y.fromDate,
            color: y.color,
            id: y.id,
            typeId: y.typeId,
            companyId: y.companyId,
            qrCode: y.qrCode,
            companyName: y.companyName,
            detailId: y.projectDetailId,
            projectName: y.projectName,
            resourceId: y.resourceId,
            resourceName: y.resourceName,
            description: y.description,
            startTime: y.startTime,
            stopTime: y.stopTime,
            startHour: getStartHour(y.startTime),
            startDayOfWeek: getStartDayOfWeek(y.startTime),
            insertedOn: y.startTime,
            updatedOn: y.stopTime,
            measurementSessionId: y.measurementSessionId,
            measurementValue: getMeasurementValue(y.typeId, y.externalApiTypeId, y.textValue, y.integerValue, y.dateValue, y.dataListValue, y.imageLink, y.externalApiValues, y.isNegative),
            integerValue: y.integerValue,
            running: y.running,
            thumbnail: y.thumbnail,
            imageId: y.imageId,
            commentText: getCommentText(y.typeId, y.externalApiTypeId, y.textValue, y.commentText),
            commentImage: y.commentImage,
            commentId: y.commentId,
            valueTypeId: y.valueTypeId,
            keyValue: y.keyValue,
            valueType: getValueType(y.valueTypeId),
            eventPrice: y.eventPrice,
            signedEventPrice: y.isProfit ? y.eventPrice : -y.eventPrice,
            externalApiTypeId: y.externalApiTypeId,
            isNegative: y.isNegative,
            isProfit: y.isProfit,
            sessionValues: y.metadata ? JSON.parse(y.metadata).map(m => m.value).join(', ') : '',
            sessionMetadata: y.metadata ? JSON.parse(y.metadata) : [],
          }));

          const selectionPromise = new Promise((resolve) => {
            const indexes = tempMeasurementRows.map((item, index) => (item.checked ? index : -1)).filter((index) => index !== -1);
            setSelection(indexes);
            setExportActive(true);
            resolve();
          });
          const measurementsPromise = new Promise((resolve) => {
            if (tempMeasurementRows !== undefined && tempMeasurementRows !== null) {
              setMeasurementRows(tempMeasurementRows.flat().sort((b, a) => a.startTime.localeCompare(b.startTime)));
              var data = chartData(tempMeasurementRows.flat());
              setChartRows(data);
              setOriginalMeasurementRows(tempMeasurementRows.flat().sort((b, a) => a.startTime.localeCompare(b.startTime)));
            }
            resolve();
          });

          // Wait for all state updates to complete before setting loading to false
          Promise.all([selectionPromise, measurementsPromise]).then(() => {
            setLoading(false); // Only set loading to false after all updates
          });
        })
        .catch((error) => {
          toast.error(`A problem occured while fetching the data`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
          console.log("Error: ", error);
        })
        .finally(() => {
          // setMeasurementRows(tempMeasurementRows.flat().sort((b, a) => a.startTime.localeCompare(b.startTime)));
          setExportActive(true);
          // chartData(tempMeasurementRows.flat());

          setRefresh(!refresh);
        });
    }

    //If the dateRanges are different --> setTimeRangeDates (to prevent that we set to many states)
    if (JSON.stringify(objNewTimeRangeDate) !== JSON.stringify(timeRangeDates)) {
      setTimeRangeDates(objNewTimeRangeDate);
    }
  };

  const setTheDate = (event) => {
    var yesterday = new Date(new Date(event));
    yesterday.setDate(yesterday.getDate() + 1);
    setTimeRangeDates({ fromDate: new Date(event), startDate: new Date(event), toDate: yesterday, endDate: yesterday });
  };

  const handleOpenSearch = () => {
    setOpenSearch(!openSearch);
  };

  const onSelectionChange = (e) => {
    var tempRows = JSON.parse(JSON.stringify(measurementRows));
    const selectedIds = e.map((index) => tempRows[index].id);
    setSelection(e);
    const updatedArray = tempRows.map((item) => (selectedIds.includes(item.id) ? { ...item, checked: true } : { ...item, checked: false }));

    var data = chartData(updatedArray.flat());
    if (JSON.parse(JSON.stringify(data)) !== JSON.parse(JSON.stringify(chartRows))) {
      setChartRows(data);
    }
  };

  const applyFilters = useCallback(
    async (filters) => {
      if (filters === null || filters === undefined) return;

      return new Promise((resolve) => {
        // Use setTimeout to make this async and prevent blocking
        setTimeout(() => {
          let varFilteredResults = JSON.parse(JSON.stringify(originalMeasurementRows)); // Clone original rows
          varFilteredResults.forEach((x) => (x.checked = true)); // Reset checked state

          filters.forEach((filter) => {
            switch (filter.columnName) {
              case "companyName":
                varFilteredResults.filter((x) => !x.companyName.toLowerCase().includes(filter.value.toLowerCase())).forEach((x) => (x.checked = false));
                break;
              case "projectName":
                varFilteredResults.filter((x) => !x.projectName.toLowerCase().includes(filter.value.toLowerCase())).forEach((x) => (x.checked = false));
                break;
              case "resourceName":
                if (varFilteredResults.some((x) => !x.resourceName.toLowerCase().includes(filter.value.toLowerCase()))) {
                  varFilteredResults
                    .filter((vfr) => !vfr.resourceName.toLowerCase().includes(filter.value.toLowerCase()))
                    .map((vfr) => {
                      vfr.checked = false;
                    });
                }
                break;
              case "description":
                if (varFilteredResults.some((x) => !x.description.toLowerCase().includes(filter.value.toLowerCase()))) {
                  varFilteredResults
                    .filter((vfr) => !vfr.description.toLowerCase().includes(filter.value.toLowerCase()))
                    .map((vfr) => {
                      vfr.checked = false;
                    });
                }
                break;
              case "valueType":
                var valueType = null;
                var unknown = "unknown";
                var waste = "waste";
                var valueAdded = "value added";
                var noValueAdded = "no value added";

                if (waste.includes(filter.value.toLowerCase())) {
                  valueType = valueTypeCodes.W;
                } else if (valueAdded.includes(filter.value.toLowerCase()) && !filter.value.toLowerCase().includes("n")) {
                  valueType = valueTypeCodes.VA;
                } else if (noValueAdded.includes(filter.value.toLowerCase()) && filter.value.toLowerCase().includes("n")) {
                  valueType = valueTypeCodes.NVA;
                }
                if (unknown.includes(filter.value.toLowerCase())) {
                  valueType = "unknown";
                }
                if (valueType !== null) {
                  if (valueType === "unknown") {
                    varFilteredResults
                      .filter((x) => x.valueTypeId !== null)
                      .map((vfr) => {
                        vfr.checked = false;
                      });
                  } else {
                    varFilteredResults
                      .filter((x) => x.valueTypeId !== valueType)
                      .map((vfr) => {
                        vfr.checked = false;
                      });
                  }
                }
                break;
              case "keyValue":
                if (filter.value !== "" && filter.value !== undefined && filter.value !== null) {
                  if (varFilteredResults.some((x) => !(x.keyValue && x.keyValue.toLowerCase().includes(filter.value.toLowerCase())))) {
                    varFilteredResults
                      .filter((vfr) => !(vfr.keyValue && vfr.keyValue.toLowerCase().includes(filter.value.toLowerCase())))
                      .map((vfr) => {
                        vfr.checked = false;
                      });
                  }
                }
                break;
              case "commentText":
                if (filter.value !== "" && filter.value !== undefined && filter.value !== null) {
                  if (varFilteredResults.some((x) => !(x.commentText && x.commentText.toLowerCase().includes(filter.value.toLowerCase())))) {
                    varFilteredResults
                      .filter((vfr) => !(vfr.commentText && vfr.commentText.toLowerCase().includes(filter.value.toLowerCase())))
                      .map((vfr) => {
                        vfr.checked = false;
                      });
                  }
                }
                break;
              case "startTime":
                if (filter.value !== "" && filter.value !== undefined && filter.value !== null) {
                  if (varFilteredResults.some((x) => !(x.keyValue && x.keyValue.toLowerCase().includes(filter.value.toLowerCase())))) {
                    varFilteredResults
                      .filter((vfr) => !(vfr.keyValue && vfr.keyValue.toLowerCase().includes(filter.value.toLowerCase())))
                      .map((vfr) => {
                        vfr.checked = false;
                      });
                  }
                }
                break;
              case "measurementValue":
                if (filter.value !== "" && filter.value !== undefined && filter.value !== null) {
                  if (
                    varFilteredResults.some(
                      (x) => !(x.measurementValue && x.measurementValue !== undefined && x.measurementValue !== "" && x.measurementValue.toString().toLowerCase().includes(filter.value.toLowerCase()))
                    )
                  ) {
                    varFilteredResults
                      .filter(
                        (vfr) =>
                          !(
                            vfr.measurementValue &&
                            vfr.measurementValue !== undefined &&
                            vfr.measurementValue !== "" &&
                            vfr.measurementValue.toString().toLowerCase().includes(filter.value.toLowerCase())
                          )
                      )
                      .map((vfr) => {
                        vfr.checked = false;
                      });
                  }
                }
                break;
              default:
            }
          });

          resolve(varFilteredResults);
        }, 0);
      });
    },
    [originalMeasurementRows]
  );

  const onFiltersChange = useCallback(
    async (filters) => {
      // Clear any existing timeout
      if (filterTimeoutRef.current) {
        clearTimeout(filterTimeoutRef.current);
      }

      // Set filtering state to show loading indicator
      setIsFiltering(true);

      // Debounce the filter operation
      filterTimeoutRef.current = setTimeout(async () => {
        try {
          const varFilteredResults = await applyFilters(filters);

          if (varFilteredResults) {
            var data = chartData(varFilteredResults.flat());
            if (JSON.parse(JSON.stringify(data)) !== JSON.parse(JSON.stringify(chartRows))) {
              setChartRows(data);
            }

            const indexes = varFilteredResults.map((item, index) => (item.checked ? index : -1)).filter((index) => index !== -1);
            setSelection(indexes);
          }
        } catch (error) {
          console.error("Error applying filters:", error);
        } finally {
          setIsFiltering(false);
        }
      }, 300); // 300ms debounce delay
    },
    [applyFilters, chartData, chartRows]
  );

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (filterTimeoutRef.current) {
        clearTimeout(filterTimeoutRef.current);
      }
    };
  }, []);

  const handleSearch = () => {
    let TempMeasurementRows;
    dataService
      .getMeasurementsByUserIdDateLocationName(GetUserId, parseNewDateToYYMMDDDash(timeRangeDates.fromDate), parseNewDateToYYMMDDDash(timeRangeDates.toDate), location, projectName)
      .then((results) => {
        TempMeasurementRows = results.map((y) => ({
          checked: true,
          projectId: y.projectId,
          toDate: y.toDate,
          fromDate: y.fromDate,
          color: y.color,
          id: y.id,
          typeId: y.typeId,
          companyId: y.companyId,
          qrCode: y.qrCode,
          companyName: y.companyName,
          detailId: y.projectDetailId,
          projectName: y.projectName,
          resourceId: y.resourceId,
          resourceName: y.resourceName,
          description: y.description,
          startTime: y.startTime,
          stopTime: y.stopTime,
          startHour: getStartHour(y.startTime),
          startDayOfWeek: getStartDayOfWeek(y.startTime),
          insertedOn: y.startTime,
          updatedOn: y.stopTime,
          measurementSessionId: y.measurementSessionId,
          measurementValue: getMeasurementValue(y.typeId, y.externalApiTypeId, y.textValue, y.integerValue, y.dateValue, y.dataListValue, y.imageLink, y.externalApiValues, y.isNegative),
          integerValue: y.integerValue,
          running: y.running,
          thumbnail: y.thumbnail,
          imageId: y.imageId,
          commentText: getCommentText(y.typeId, y.externalApiTypeId, y.textValue, y.commentText),
          commentImage: y.commentImage,
          commentId: y.commentId,
          keyValue: y.keyValue,
          valueType: getValueType(y.valueTypeId),
          eventPrice: y.eventPrice,
          signedEventPrice: y.isProfit ? y.eventPrice : -y.eventPrice,
          externalApiTypeId: y.externalApiTypeId,
          isNegative: y.isNegative,
          isProfit: y.isProfit,
          sessionValues: y.metadata ? JSON.parse(y.metadata).map(m => m.value).join(', ') : '',
          sessionMetadata: y.metadata ? JSON.parse(y.metadata) : [],
        }));
        // setMeasurementRows(TempMeasurementRows.flat().sort((b, a) => a.startTime.localeCompare(b.startTime)));
        setExportActive(true);
        // chartData(TempMeasurementRows.flat());
        setRefresh(!refresh);
      });

    // refresh page
    window.location.reload();
  };

  return (
    <React.Fragment>
      {isLoading && (
        <div className={classes.loadingChart}>
          <Spin width="100px" height="100px" color="#C3996B"></Spin>
        </div>
      )}
      <TitlePage Text="Results" {...props} backbutton={true} />
      <Box
        sx={{
          maxWidth: "90%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          marginRight: "auto",
          marginLeft: "auto",
          marginTop: "120px",
        }}
      >
        <div className={classes.header}>
          {selectedProject && (
            <button className={classes.backButton} onClick={() => navigate("/projectreportoverview")}>
              <ChevronLeft className={classes.backButton__icon} />
              Back to project overview
            </button>
          )}
          <>
            <h1>{!selectedProject ? "Last 24 hours" : "Project timeline"}</h1>
          </>
        </div>
        <Box>
          {selectedProject && (
            <div className={classes.fullHeader}>
              <h2 className={classes.projectTitle}>{project.projectName}</h2>
              <div className={classes.header__detailContainer}>
                <div className={classes.header__detail}>
                  <MapPin className={classes.header__detailIcon} />
                  <p className={classes.header__detailText}>{project.resourceDescription}</p>
                </div>
                <div className={classes.header__detail}>
                  <Factory className={classes.header__detailIcon} />
                  <p className={classes.header__detailText}>{project.companyName}</p>
                </div>
              </div>
            </div>
          )}
          <Box
            className={classes.container}
            sx={{ borderRadius: "8px", borderTopRightRadius: selectedProject ? "0px !important" : "8px", borderTopLeftRadius: selectedProject ? "0px !important" : "8px" }}
          >
            <div className={classes.buttonContainer}>
              <div className={classes.buttonContainer__start}>
                <div ref={anchorRef} className={classes.buttonContainer__buttonGroup}>
                  <button onClick={handleOpenSearch} className={classes.primaryIconButton}>
                    Filters
                    <ChevronDown style={{ transform: openSearch ? "rotate(180deg)" : "rotate(0deg)" }} className={classes.iconButton__icon} />
                  </button>
                  <Tooltip
                    title="Refresh measurements"
                    placement="top"
                    disableInteractive
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, -4],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <button onClick={handleSearch} className={classes.iconButton}>
                      <RefreshCcw className={classes.iconButton__icon} />
                    </button>
                  </Tooltip>
                </div>
                <BoolToggle disabled={false} size="large" label="Display linear" onChange={setShowLinearTimeline} boolValue={showLinearTimeline} />
              </div>
            </div>
            <Collapse in={openSearch} timeout="auto" unmountOnExit style={{ marginBottom: "16px" }}>
              <Box className={classes.stylingBlock}>
                <div className={classes.filterBlock}>
                  <div className={classes.blockStyle}>
                    <DatePickerText Text="Timestamp: " />
                  </div>
                  <div className={classes.filterBlock__dateFiltersContainer}>
                    <MyDateTimePicker {...props} value={timeRangeDates.fromDate} toDate={timeRangeDates.toDate} action={setTheDate} />
                    <TimeRangeChart updateDataRange={updateDataRange} timeRangeDates={timeRangeDates}></TimeRangeChart>
                  </div>
                </div>

                <Typography fontSize={15} style={{ marginRight: "5%", lineHeight: "0", textAlign: "right", color: "rgba(0, 0, 0, 0.3)" }} component="div">
                  Your results window is 24 hours from your timestamp.
                </Typography>
              </Box>
            </Collapse>

            <div className={classes.timeLineChartContainer}>
              {chartRows.length === 0 && (
                <div className={classes.emptyStateContainer}>
                  <div className={classes.emptyStateCard}>
                    <p className={classes.emptyStateCard__title}>No measurements</p>
                    <p className={classes.emptyStateCard__subtitle}>There are no measurements to display</p>
                  </div>
                </div>
              )}
              <TimeLineChart
                data={chartRows.length === 0 ? chartDummyData : chartRows}
                visualisationType={showLinearTimeline ? timeLineVisualisationTypes.LINEAREVENTS : timeLineVisualisationTypes.SPLIT}
                from={parseNewDateToDDMMYYYWithoutSeconds(timeRangeDates.fromDate)}
                to={parseNewDateToDDMMYYYWithoutSeconds(timeRangeDates.toDate)}
              />
            </div>
            <Divider style={{ marginBottom: "1rem", marginTop: "1rem" }}></Divider>
            <div style={{ position: "relative" }}>
              {isFiltering && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "4px",
                  }}
                >
                  <Spin width="30px" height="30px" color="#C3996B" />
                </div>
              )}
              <DevExDataTable data={measurementRows} columns={resultColumns} onSelectionChange={onSelectionChange} selection={selection} handleFiltersChange={onFiltersChange}></DevExDataTable>
            </div>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default ResultsPage;
const useStyles = makeStyles((theme) => ({
  blockStyle: {
    // width: '32%',
  },
  container: {
    boxSizing: "border-box",

    position: "relative",

    background: "#FFFFFF",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    paddingBottom: "1.5rem",
    paddingTop: "1.5rem",
    marginRight: "auto",
    width: "100%",
    marginLeft: "auto",
  },

  header: {
    width: "100%",
    height: "40px",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    marginBottom: "16px",
  },

  backButton: {
    position: "absolute",
    top: "95px",

    display: "flex",
    alignItems: "center",
    gap: "4px",

    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    color: "#0C0E29",
    opacity: ".8",

    border: "none",
    padding: "0px",

    transition: "opacity ease-in-out .1s",

    "&:hover": {
      opacity: "1",
      cursor: "pointer",
    },
  },

  backButton__icon: {
    height: "16px",
    width: "16px",

    strokeWidth: "1.4px",
  },

  noTopBorderRadius: {
    borderTopLeftRadius: "0px !important",
    borderTopRightRadius: "0px !important",
  },

  emptyStateCard: {
    maxWidth: "320px",
    boxSizing: "border-box",

    padding: "16px",

    display: "flex",
    flexDirection: "column",

    alignItems: "center",

    backgroundColor: "white",

    border: "1px solid #EDEDED",
    borderRadius: "8px",
  },

  chartHeader: {
    boxSizing: "border-box", // Ensures padding/border don't affect width
    width: "100%",
    display: "flex",
    flexDirection: "row",
    minWidth: "100%",
    justifyContent: "center",
    alignItems: "center",
  },

  fullHeader: {
    width: "100%",
    boxSizing: "border-box",

    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "8px",

    backgroundColor: "#C3996B",
    color: "white",

    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",

    padding: "16px",
  },

  projectTitle: {
    color: "white",
  },

  header__detailContainer: {
    display: "flex",
    gap: "24px",
  },

  header__detail: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  header__detailIcon: {
    width: "20px",
    height: "20px",

    strokeWidth: "1.4px",

    display: "block",
  },

  header__detailText: {
    margin: "0px",
  },

  extraInfo: {
    display: "flex",
    justifyContent: "end",
  },
  loadingChart: {
    height: "100vh",
    width: "100%",
    zIndex: "999",
    top: "0px",
    position: "fixed",
    borderRadius: "8px",
    backgroundColor: "rgba(156,156,156,0.5)",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  exportContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    marginLeft: "1.5rem",
    alignItems: "flex-end",
    flexWrap: "wrap",
  },
  dateSelection: {
    display: "flex",
    flexDirection: "column",
  },
  filterBlock: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      // flexWrap: 'nowrap',
      // justifyContent: 'flex-start',
      // gap: "15px"
    },
    [theme.breakpoints.down("sm")]: {
      // flexWrap: 'wrap',
      // justifyContent: 'space-evenly',
    },
  },

  filterBlock__dateFiltersContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  filterItem: {
    [theme.breakpoints.up("sm")]: {
      marginTop: "25px",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "15px",
      width: "100%",
      textAlign: "center",
      justifyContent: "center",
    },
  },
  filterButton: {
    backgroundColor: "#C3996B !important",
  },
  stylingBlock: {
    backgroundColor: "#f0f0f0",
    borderRadius: "6px",
    padding: "25px",
  },

  buttonContainer: {
    paddingBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",

    [theme.breakpoints.up("sm")]: {
      flexWrap: "nowrap",
    },

    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
  },

  buttonContainer__start: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },

  buttonContainer__buttonGroup: {
    display: "flex",
    alignItems: "center",

    "& button:first-child": {
      borderTopRightRadius: "0px",
      borderBottomRightRadius: "0px",
    },

    "& button:last-child": {
      borderTopLeftRadius: "0px",
      borderBottomLeftRadius: "0px",
    },
  },

  primaryIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingRight: "8px",

    border: "none",
    borderRadius: "4px",

    borderRight: "1px solid #D8BEA2",

    fontSize: "16px",
    color: "white",
    backgroundColor: "#C3996B",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    transition: "all 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#a77d4f",
      color: "white",
      cursor: "pointer",
    },
  },

  iconButton: {
    height: "40px",
    width: "40px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "#C3996B",

    transition: "all 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#a77d4f",
      color: "white",
      cursor: "pointer",
    },
  },

  iconButton__icon: {
    height: "20px",
    width: "20px",

    display: "block",
  },

  buttonContainer__end: {
    display: "flex",
    gap: "8px",
  },

  secondaryButton: {
    height: "40px",
    padding: "0 16px",

    border: "1px solid #C3996B",
    borderRadius: "4px",

    fontSize: "16px",
    color: "#C3996B",
    backgroundColor: "transparent",

    transition: "all 0.2s ease-in-out",

    userSelect: "none",

    "&:hover": {
      backgroundColor: "#a77d4f",
      color: "white",
      border: "1px solid #a77d4f",
      cursor: "pointer",
    },
  },

  secondaryDisabledButton: {
    height: "40px",
    padding: "0 16px",

    border: "1px solid #DCDCDC",
    borderRadius: "4px",

    fontSize: "16px",
    color: "#DCDCDC",
    backgroundColor: "transparent",

    transition: "all 0.2s ease-in-out",

    userSelect: "none",

    "&:hover": {
      cursor: "not-allowed",
    },
  },

  timeLineChartContainer: {
    position: "relative",
    minHeight: "400px",
  },

  emptyStateContainer: {
    width: "100%",
    height: "100%",

    position: "absolute",
    left: "0px",
    top: "0px",
    zIndex: "998",

    backgroundColor: "rgba(237, 237, 237, 0.48)",
    backdropFilter: "blur(8px)", // Apply blur to background elements

    borderRadius: "8px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  emptyStateCard__title: {
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    color: "rgba(12, 14, 41, 1)",

    margin: "0px",
    marginBottom: "8px",
  },

  emptyStateCard__subtitle: {
    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    color: "rgba(12, 14, 41, 0.8)",

    textAlign: "center",

    margin: "0px",
  },
}));
